
import { Link } from "react-router-dom";

function AboutIconLink() {
  return (
    <div className="about-link">
      <Link to="/about">
        About
      </Link>
    </div>
  );
}

export default AboutIconLink;
